module.exports = __webpack_public_path__ + "static/media/skater2.6e6b1af1.jpg";